import axios from "axios";

// Same-origin fallback: the ingress routes /api to the backend, so a missing build-time
// env var can never leave the app posting to "/undefined/api/...".
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.response.use(undefined, (e) => {
  const cfg = e?.config || {};
  console.error(`[api] ${e?.response?.status || "network"} ${(cfg.method || "").toUpperCase()} ${cfg.baseURL || ""}${cfg.url || ""}`);
  return Promise.reject(e);
});

export const submitApplication = (answers, attribution = {}) =>
  api.post("/applications", { answers, source: "Get Started form", attribution, application_type: "Artist" }).then((r) => r.data);
export const getSchedulerConfig = () => api.get("/scheduler/config").then((r) => r.data);
export const saveSchedulerConfig = (body) => api.put("/scheduler/config", body).then((r) => r.data);
export const recordBooking = (id, body) => api.post(`/leads/${id}/booking`, body).then((r) => r.data);
export const getLeads = (params) => api.get("/leads", { params }).then((r) => r.data);
export const getLead = (id) => api.get(`/leads/${id}`).then((r) => r.data);
export const setLeadStatus = (id, status) => api.patch(`/leads/${id}/status`, { status }).then((r) => r.data);
export const clearReview = (id) => api.post(`/leads/${id}/clear-review`).then((r) => r.data);
export const saveDiscovery = (id, body) => api.put(`/leads/${id}/discovery`, body).then((r) => r.data);
export const saveAnr = (id, body) => api.put(`/leads/${id}/anr`, body).then((r) => r.data);
export const getCatalog = () => api.get("/catalog").then((r) => r.data);
export const getNotionStatus = () => api.get("/notion/status").then((r) => r.data);
export const discoverNotion = (urls) => api.post("/notion/discover", { urls }).then((r) => r.data);
export const provisionNotion = () => api.post("/notion/provision").then((r) => r.data);
export const saveNotionConfig = (databases) => api.put("/notion/config", { databases }).then((r) => r.data);
export const verifyNotion = () => api.post("/notion/verify").then((r) => r.data);
export const pullNotion = () => api.post("/notion/pull").then((r) => r.data);
export const syncLead = (id) => api.post(`/leads/${id}/notion-sync`).then((r) => r.data);

export const submitPartnerApplication = (answers, petition, attribution = {}) =>
  api.post("/partners/applications", { answers, petition, source: "Creative Service Provider form", attribution }).then((r) => r.data);
export const getPartnerApplications = (params) => api.get("/partners/applications", { params }).then((r) => r.data);
export const getPartnerApplication = (id) => api.get(`/partners/applications/${id}`).then((r) => r.data);
export const setPartnerStatus = (id, status) => api.patch(`/partners/applications/${id}/status`, { status }).then((r) => r.data);
export const savePartnerNotes = (id, internal_notes) => api.put(`/partners/applications/${id}/notes`, { internal_notes }).then((r) => r.data);
export const syncPartner = (id) => api.post(`/partners/applications/${id}/notion-sync`).then((r) => r.data);

export const uploadResume = (file, onProgress) => {
  const body = new FormData();
  body.append("file", file);
  return api.post("/uploads/resume", body, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  }).then((r) => r.data);
};

export const submitInquiry = (body) => api.post("/inquiries", body).then((r) => r.data);
export const listInquiries = (params) => api.get("/inquiries", { params }).then((r) => r.data);
export const getInquiry = (id) => api.get(`/inquiries/${id}`).then((r) => r.data);
export const setInquiryStatus = (id, status) => api.patch(`/inquiries/${id}/status`, { status }).then((r) => r.data);
export const saveInquiryNotes = (id, internal_notes) => api.put(`/inquiries/${id}/notes`, { internal_notes }).then((r) => r.data);
export const syncInquiry = (id) => api.post(`/inquiries/${id}/notion-sync`).then((r) => r.data);

export const submitNetworkApplication = (role, body) => api.post(`/network/${role}/applications`, body).then((r) => r.data);
export const listNetworkApplications = (role, params) => api.get(`/network/${role}/applications`, { params }).then((r) => r.data);
export const getNetworkApplication = (role, id) => api.get(`/network/${role}/applications/${id}`).then((r) => r.data);
export const setNetworkStatus = (role, id, status) => api.patch(`/network/${role}/applications/${id}/status`, { status }).then((r) => r.data);
export const saveNetworkNotes = (role, id, internal_notes) => api.put(`/network/${role}/applications/${id}/notes`, { internal_notes }).then((r) => r.data);
export const syncNetworkApplication = (role, id) => api.post(`/network/${role}/applications/${id}/notion-sync`).then((r) => r.data);

export const money = (n) => (n === null || n === undefined ? "—" : `$${Number(n).toLocaleString()}`);
export const errText = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail) return typeof detail === "string" ? detail : "Please check your answers and try again.";
  if (e?.response) return "We couldn't reach the Sabrea server just now. Your answers are saved — please try again.";
  return "You appear to be offline. Your answers are saved — please try again.";
};
